export default class UpdateSnippet {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    this.context.gateways.snippetCount.update(id);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/update_snippet_count.js